import script from "./ViewMasterClass.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewMasterClass.vue?vue&type=script&setup=true&lang=js"

import "./ViewMasterClass.vue?vue&type=style&index=0&id=53486acb&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53486acb"]])

export default __exports__